export interface ResourceIntegration {
  id: string;
  integrationType: IntegrationType;
  resourceType: "Location" | "Space";
  resourceID: string;
  internalCode: string;
  properties: { [name: string]: string };
}

export enum IntegrationFlexspaceProperty {
  LocationName = "location_name",
}

export enum IntegrationType {
  TRANZILA = "tranzila",
}

export function toResourceIntegration(data: any): ResourceIntegration {
  return {
    id: data.id,
    integrationType: data.integration_type,
    resourceType: data.resource_type,
    resourceID: data.resource_id,
    internalCode: data.internal_code,
    properties: data.properties,
  };
}

export type TranzilaAdditionalParams = { [name: string]: string };

export function getTranzilaAdditionalParams(
  integration?: ResourceIntegration
): TranzilaAdditionalParams | undefined {
  if (!integration) {
    return;
  }

  const tranzilaLocationNameProperty =
    integration.properties[IntegrationFlexspaceProperty.LocationName];
  if (!tranzilaLocationNameProperty) {
    return;
  }

  const result: { [name: string]: string } = {};
  result[tranzilaLocationNameProperty] = integration.internalCode;
  return result;
}
